import { render, staticRenderFns } from "./Bakery.vue?vue&type=template&id=63eeaca9&scoped=true&"
import script from "./Bakery.vue?vue&type=script&lang=js&"
export * from "./Bakery.vue?vue&type=script&lang=js&"
import style0 from "./Bakery.vue?vue&type=style&index=0&id=63eeaca9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eeaca9",
  null
  
)

/* custom blocks */
import block0 from "./Bakery.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports